import {
  addDays,
  differenceInDays,
  format,
  parse,
} from "date-fns";
import React, { useEffect, useState } from "react";
import {
  getAvailability,
  getUpcomingBookingsByDate,
  removeAppointment,
} from "../../services/DoctorService";
import {
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import { timezone } from "../../Utils/AllConstant";
import DateInput from "../../commonComponent/CutomDatePicker";
import Loader from "../../commonComponent/Loader";
import { useNavigate } from "react-router-dom";
import CustomDeleteModal from "./CustomDeleteModal";
import PopoverList from "./ViewAppointmentPopover";
import { useDateTimezone } from "../../Context/DateTimezoneContext";
// import EventViewModal from "./EventViewModal";

const MyAppointments = () => {
  // console.log(addMonths(startOfMonth(new Date()),3));
  const navigate = useNavigate();

  const [timeZoneObject, setTimeZoneObject] = useState({});
  const [disabledDates, setDisabledDates] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  // const [BookingList, setBookingList] = useState([]);
  const [IndividualList, setIndividualList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [isLoading, setLoader] = useState(true);
  const [appointId, setAppointId] = useState("");
  // const urlPattern = new RegExp(
  //   "((http|https)://)(www.)?" +
  //     "[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]" +
  //     "{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)"
  // );

  const {dashboardDate,setDashboardDate} = useDateTimezone()

  let initialDate = dashboardDate ? format(new Date(dashboardDate), "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd");
  useEffect(() => {
    // getSessionList();
    // getBookingList(initialDate);
    setSelectedDate(new Date(initialDate))
    getTodaysBookingList(initialDate);
    getAvailabilityList();
    setTimeZoneObject(timezone[0]);
  }, []);

  useEffect(() => {
    // getSessionList();
    // getBookingList(initialDate);
    setSelectedDate(new Date(initialDate))
    getTodaysBookingList(initialDate);
    getAvailabilityList();
    setTimeZoneObject(timezone[0]);
  }, [dashboardDate]);

  // useEffect(()=>{
  //   setSelectedDate(new Date(date))
  //   getTodaysBookingList(format(date, "yyyy-MM-dd"));
  // },[date])



  // const handleConversion = (reminder) => {
  //   let time = format24Time(reminder.startTime) + ":00.000+05:30";
  //   return time;
  // };

  // const getBookingList = async (date) => {
  //   try {
  //     const response = await getBookingByStatus(date, "pending");
  //     if (response.status === 200) {
  //       setBookingList(response?.data?.data.reverse());
  //       setGroupList(
  //         response?.data?.data.filter((res) => res.type === "group")
  //       );
  //       setIndividualList(
  //         response?.data?.data.filter((res) => res.type === "session")
  //       );
  //     } else {
  //       showToastError(response?.data || response.message);
  //     }
  //   } catch (error) {
  //     error?.data?.data && alert(error?.data?.data || error.data?.message);
  //   }
  // };
  const getTodaysBookingList = async (date) => {
    try {
      const response = await getUpcomingBookingsByDate(date);
      if (response.status === 200) {
        setGroupList(
          response?.data?.data.filter((res) => res.type === "group")
        );
        setIndividualList(
          response?.data?.data.filter((res) => res.type === "session")
        );
      } else {
        showToastError(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
        setLoader(false);
    }
  };
  const deleteAppointment = async (id) => {
    try {
      const response = await removeAppointment(id);
      console.log(response);
      if (response.status === 200) {
        showToastSuccess(
          response?.data?.data || "Session deleted successfully."
        );
        getTodaysBookingList(format(selectedDate, "yyyy-MM-dd"));
      } else {
        showToastError(
          response?.data?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
      setLoader(false);
    }
  };


  const getAvailabilityList = async () => {
    try {
      let dates = [];
      getAvailability()
        .then((response) => {
          if (response.status === 200) {
            //console.log(response?.data?.data[0]?.availability_details);
            response?.data?.data[0]?.availability_details?.map((dt) => {
              let start = parse(dt.start_date, "yyyy-MM-dd", new Date());
              let end = parse(dt.end_date, "yyyy-MM-dd", new Date());
              let diff = Math.abs(differenceInDays(start, end));
              for (let i = 0; i <= diff; i++) {
                dates.push(addDays(start, i));
              }
            });
          } else {
            alert(response?.data || response.message);
          }
        })
        .then((_) => {
          //console.log(dates);
          setDisabledDates(dates);
        })
        .finally((_) => {
          setLoaded(true);
        });
    } catch (error) {
      error?.data?.data && alert(error?.data?.data || error.data?.message);
      setLoader(false);
    }
  };
  // const createMeeting = async (request) => {
  //   try {
  //     // const time24h = request?.time?.split('-')?.[0]?.trim();
  //     const params = {
  //       topic: "Doctor appointment",
  //       type: 2,
  //       start_time: request.startTime,
  //       duration: "30",
  //       settings: {
  //         host_video: true,
  //         participant_video: true,
  //         join_before_host: true,
  //         mute_upon_entry: "true",
  //         watermark: "true",
  //         audio: "voip",
  //         auto_recording: "cloud",
  //         email_notification: true,
  //         registrants_email_notification: true,
  //         meeting_invitees: [
  //           {
  //             email: request?.userId?.email,
  //           },
  //         ],
  //       },
  //     };
  //     const meetingResponse = await createZoomMeetingService(params);
  //     if (meetingResponse) {
  //       return meetingResponse;
  //     }
  //   } catch (error) {
  //     if (error?.data?.data) {
  //       navigate("/myprofile");
  //       showToastError(
  //         error?.data?.data || error.data?.message || "Some error occurred"
  //       );
  //     }
  //   }
  // };
  // const updateAppointmentBooking = async (payload) => {
  //   try {
  //     const response = await confirmBookingStatus(payload);
  //     if (response.status === 200) {
  //       showToastSuccess(response?.data?.message);
  //       getTodaysBookingList(initialDate);
  //     } else {
  //       showToastError(response?.data || response.message);
  //     }
  //   } catch (error) {
  //     error?.data?.data &&
  //       showToastError(error?.data?.data || error.data?.message);
  //   }
  // };

  // const updateBooking = async (payload, request) => {
  //   try {
  //     if (payload.status === "confirmed") {
  //       const meetingResponse = await createMeeting(request);
  //       if (meetingResponse) {
  //         payload.sessionLink_doctor = meetingResponse.start_url;
  //         payload.sessionLink_user = meetingResponse.join_url;
  //         const response = await confirmBookingStatus(payload);
  //         if (response.status === 200) {
  //           showToastSuccess(response?.data?.data);
  //           // getBookingList(initialDate);
  //           getTodaysBookingList(initialDate);
  //         } else {
  //           showToastError(response?.data || response.message);
  //         }
  //       }
  //     } else {
  //       const response = await confirmBookingStatus(payload);
  //       if (response.status === 200) {
  //         showToastSuccess(response?.data?.data);
  //         // getBookingList(initialDate);
  //         getTodaysBookingList(initialDate);
  //       } else {
  //         showToastError(response?.data || response.message);
  //       }
  //     }
  //   } catch (error) {
  //     error?.data?.data &&
  //       showToastError(error?.data?.data || error.data?.message);
  //   }
  // };

  // const getUserData = async (user_id) => {
  //   if (user_id === "") {
  //     return;
  //   }

  //   try {
  //     const response = await getUserInfoService(user_id);
  //     if (response.status === 200) {
  //       console.log(response?.data?.data[0]);
  //       return response?.data?.data[0];
  //     }
  //   } catch (error) {}
  // };

  return (
    <>
      <div
        className="mt-4"
        style={{
          backgroundColor: "white",
          // , borderRadius: "8px", boxShadow: " 0px 4px 20px #ccc9ca"
        }}
      >
        <div className="d-flex align-items-center mb-3 justify-content-between">
          <div className="my-3 w-50">
            <h4 className="px-2 mt-2 headFont">Appointments</h4>
            <p className="px-2 mb-2 resFont">
              View latest appointments to groups or individual sessions.
            </p>
          </div>

          <div className=" my-3 d-flex w-50 justify-content-end align-items-center ">
            <div className="px-2 ">
              <button
                className="description_btntoday w-100"
                style={{
                  backgroundColor: "#1f7e78",
                  borderColor: "#1f7e78",
                }}
                onClick={() => {
                  setSelectedDate(new Date());
                  getTodaysBookingList(format(new Date(), "yyyy-MM-dd"));
                }}
              >
                Today
              </button>
            </div>
            <div className="px-2">
              <DateInput
                value={selectedDate}
                onChangeDate={(date) => {
                  // console.log(date, "dateee");
                  setDashboardDate(date);
                  setSelectedDate(date);
                  // setError({ ...error, start_date: false })
                  getTodaysBookingList(format(date, "yyyy-MM-dd"));
                }}
                // maxDate={}
                // minDate={new Date()}
                inputClassName={
                  "description_inputf d-flex align-items-center mb-0"
                }
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "-20px" }} />

        <div className="my-2">
          <div className="d-flex">
            <div className="col-md-12 mt-2">
              <h4 className="px-2 headFont">Individual Appointments</h4>
            </div>
          </div>
          <CustomDeleteModal
            title={"Delete"}
            content1={"Are you sure you want to delete this Appointment?"}
            modalId={"individualdeleteSession"}
            button2={"No"}
            button1={"Yes"}
            onDelete={() => deleteAppointment(appointId)}
          />
          <div className="table_resouter mt-2 table-responsive " style={{ height: "auto" }}>
            {isLoading ? (
              <center>
                <Loader
                  visible={isLoading}
                  style={{ top: "-15px", position: "relative" }}
                />{" "}
              </center>
            ) : IndividualList.length > 0 ? (
              <table className="table appointment_table1 table_resinner2 resFont">
                <thead>
                  <tr className="text-center resFont">
                    <th scope="col">Name</th>
                    <th scope="col">Service Name</th>
                    <th scope="col">Service type</th>
                    <th scope="col">Appointment Date</th>
                    <th scope="col">Appointment Time</th>
                    <th scope="col">Service Action</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {IndividualList.length > 0 && <PopoverList dt={IndividualList} setAppointId={setAppointId} getTodaysBookingList={getTodaysBookingList}/>}
                </tbody>
              </table>
            ) : (
              <div className="card p-2 mt-2">
                <div className="card-body">
                  There are currently no appointments for this date.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="my-2">
        <div className="d-flex">
          <div className="col-md-12 mt-2">
            <h4 className="px-2 headFont">Group Appointments</h4>
          </div>
        </div>
        <CustomDeleteModal
          title={"Delete"}
          content1={"Are you sure you want to delete this Appointment?"}
          modalId={"groupdeleteSession"}
          button2={"No"}
          button1={"Yes"}
          onDelete={() => deleteAppointment(appointId)}
        />
        <div className="table_resouter" style={{ height: "auto" }}>
          {isLoading ? (
            <center>
              <Loader
                visible={isLoading}
                style={{ top: "-15px", position: "relative" }}
              />{" "}
            </center>
          ) : GroupList.length > 0 ? (
            <table className="table appointment_table1 table_resinner2 resFont">
              <thead>
                <tr className="text-center resFont">
                  {/* <th scope="col">Name</th> */}
                  <th scope="col">Service Name</th>
                  {/* <th scope="col">people</th> */}
                  <th scope="col">Service Type</th>
                  <th scope="col">Appointment Date</th>
                  <th scope="col">Appointment Time</th>
                  <th scope="col">capacity</th>
                  <th scope="col">Service Action</th>
                  <th scope="col">action</th>
                </tr>
              </thead>
              <tbody>{GroupList?.length > 0 && <PopoverList dt={GroupList} setAppointId={setAppointId} getTodaysBookingList={getTodaysBookingList}/>}</tbody>
            </table>
          ) : (
            <div className="card p-2 mt-2">
              <div className="card-body">
                There are currently no appointments for this date.
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MyAppointments;
